// extracted by mini-css-extract-plugin
export default {"hidden":"a2iSu2"};